import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import _pick from 'lodash/pick';
import _omit from 'lodash/omit';
import React from 'react';
import PropTypes from 'prop-types';
import { HelocCalculator as HelocCalculator$1, HelocCalculatorShape } from '@zillow/zrs-cms';

var BlockHelocCalculator = function BlockHelocCalculator(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  return /*#__PURE__*/React.createElement(HelocCalculator$1, _extends({
    defaultValues: _pick(attrs, Object.keys(HelocCalculatorShape))
  }, _omit(attrs, Object.keys(HelocCalculatorShape)), {
    key: index
  }));
};
BlockHelocCalculator.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  attrs: PropTypes.shape(HelocCalculatorShape)
} : {};
var HelocCalculator = BlockHelocCalculator;

export { HelocCalculator as default };
